import { render } from "./visitorsAtriclesEditor.vue?vue&type=template&id=fb7114bc"
import script from "./visitorsAtriclesEditor.vue?vue&type=script&lang=js"
export * from "./visitorsAtriclesEditor.vue?vue&type=script&lang=js"

import "./visitorsAtriclesEditor.vue?vue&type=style&index=0&id=fb7114bc&lang=scss"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__